import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import db from '../../helpers/db'
import {
  Image,
  Container,
  Segment,
  Message,
  Checkbox,
  Icon,
  Card,
  Dropdown,
  Popup
} from 'semantic-ui-react'

class Game extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: null,
      active: props.game.active,
      completed: props.game.state.quarter === 5
    }
  }

  static propTypes = {
    game: PropTypes.object.isRequired,
    delete: PropTypes.func.isRequired
  }

  toggleActive = () => {
    const { active, completed } = this.state
    if (completed) return
    this.setState(
      {
        loading: true
      },
      () => {
        return db.games
          .update(this.props.game.id, {
            active: !active
          })
          .then(() =>
            this.setState({
              active: !active
            })
          )
          .catch(({ message }) => {
            this.setState({
              error: message
            })
          })
          .then(() =>
            this.setState({
              loading: false
            })
          )
      }
    )
  }

  render() {
    const { game } = this.props
    const { active, loading, error, completed } = this.state
    return (
      <Card fluid raised color="orange" key={game.id}>
        {completed ? (
          <Message attached success icon="check" header="Completed" />
        ) : (
          <Segment raised color="orange" textAlign="right" inverted>
            <Popup
              basic
              trigger={
                <Dropdown
                  direction="left"
                  labeled
                  icon={<Icon size="big" name="setting" />}
                >
                  <Dropdown.Menu>
                    <Dropdown.Item
                      as={Link}
                      disabled={!active}
                      to={`/admin/games/${game.id}/controller`}
                      icon="game"
                      text={
                        active ? 'Controller' : 'Activate game for controller'
                      }
                    />
                    <Dropdown.Item
                      as={Link}
                      to={`/admin/game/${game.id}`}
                      icon="pencil"
                      disabled={active}
                      text={active ? 'Deactivate game to edit' : 'Edit'}
                    />
                    <Dropdown.Item
                      icon="trash"
                      onClick={this.props.delete}
                      disabled={active}
                      text={active ? 'Deactivate game to delete' : 'Delete'}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              }
              content="Settings"
            />
          </Segment>
        )}
        <Container textAlign="center">
          {error && <Message error content={error} />}
          <h3 style={{ display: 'inline' }}>{game.team2.name} </h3>
          <Image inline size="small" src={game.team2.logo} />
          <h4>at</h4>
          <Image inline size="small" src={game.team1.logo} />
          <h3 style={{ display: 'inline' }}> {game.team1.name}</h3>
        </Container>
        <Card.Content extra>
          <Segment loading={loading} color="orange" textAlign="center">
            <Popup
              trigger={
                <Checkbox
                  slider
                  onClick={this.toggleActive}
                  checked={active && !completed}
                />
              }
              basic
              content="Toggle active"
            />
            <h5>{active && !completed ? 'Active' : 'Inactive'}</h5>
          </Segment>
        </Card.Content>
      </Card>
    )
  }
}

export default Game



// WEBPACK FOOTER //
// ./src/components/Admin/Game.jsx